import crypto from 'crypto';
const cfgData = require("../config/cfg.json");
const sign_key = "evcourse#$@20230824";

const getCookie = function (name) {
	var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)"); //正则匹配
	if (arr = document.cookie.match(reg)) {
		return unescape(arr[2]);
	}
	else {
		return null;
	}
}

const Format = function (fmt) { // author: meizz
    var o = {
        "M+": this.getMonth() + 1, // 月份
        "d+": this.getDate(), // 日
        "h+": this.getHours(), // 小时
        "m+": this.getMinutes(), // 分
        "s+": this.getSeconds(), // 秒
        "q+": Math.floor((this.getMonth() + 3) / 3), // 季度
        "S": this.getMilliseconds() // 毫秒
    };
    if (/(y+)/.test(fmt))
        fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
            return fmt;
}

// 去除标签
const htmlDecode = function(str) {
    var s = "";
    if (str.length === 0) return "暂无课程详情";
    s = str.replace(/&amp;/g, "&");
    s = s.replace(/&lt;/g, "<");
    s = s.replace(/&gt;/g, ">");
    s = s.replace(/&#39;/g, '"');
    s = s.replace(/&quot;/g, '"');
    return s;
}

// eslint-disable-next-line no-irregular-whitespace
const GetClear = function(str) { 
    if (str == null || str == undefined) {
        return '';
    } else {
        var tem = str
            .replace(/&lt;/g, "<")
            .replace(/&gt;/g, ">")
            .replace(/&quot;/g, "\"")
            .replace(/&apos;/g, "'")
            .replace(/&amp;/g, "&")
            .replace(/&nbsp;/g, '').replace(/<\/?.+?\/?>/g, '').replace(/<[^>]+>/g, "")
        return tem;
    }
}

const group_sign = function (params) {
	let base_params = {
	  platform: 32, //设备类型
	  app_version: "1.0.0", //版本号
      app_name:'web',
      os_name:'web',
      busi_id: cfgData.params.merchant_id,
	  req_time: parseInt(new Date().getTime() / 1000), //[必填]通用参数调用时间（毫秒值）
	};
	let allParams = Object.assign({}, base_params, params);
	let sign = create_sign(allParams, sign_key);
    allParams.sign = sign;
	return allParams;
  }

const create_sign = function (data, key) {
    let md5 = crypto.createHash('md5');
    let array = [];
    for(let k in data){
        if(k == "sign"){
            continue;
        }
        array.push(k);
    }
    array.sort();
    var app_key = "";
    for (var i = 0; i < array.length; i++) {
        var list = array[i];
        app_key += array[i] + "=" + data[list] + "&";
    }
    app_key += "&" + key;
    var buf = new Buffer(app_key);
    var str = buf.toString("utf-8");
    var password = md5.update(str).digest('hex');
    return password;
}

const delCookie = function(name) {
	var exp = new Date();
	exp.setTime(exp.getTime() - 1);
	var cval = getCookie(name);
	if (cval != null) document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString()+";path=/";
}
const sortKey = function(arr, key){
    return arr.sort(function(a, b){
      var x = a[key];
      var y = b[key];
      return ((x<y)?-1:(x>y)?1:0)
    })
  }
export {group_sign, create_sign, getCookie,delCookie, htmlDecode, GetClear,Format,sortKey}

